module.exports = __webpack_public_path__ + "static/media/DSC_0068.ee1e8b98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0068.jpg
// module id = 686
// module chunks = 0